<template>
  <div class="page-right" :style="{ 'width': right_widthPX + 'px' ,'height': LeftMenu_heightPX + 'px' }" v-if="!specialEvent">
    <div class="right_details_wrap relative-position page-match-detail fit">
      <div class="load-data-wrap col is-detail details_data_load" style="display: none; margin-top: 113px;">
        <div class="fit"></div>
        <div class="column yb-flex-center empty">
          <!-- <div class="loading-wrap right_details_loading">
            <div class="img-loading custom-format-img-loading"></div>
            <div class="text-center loading-text flex items-end justify-center">
              <span>{{ langList.sportTableLang['SPORT_TABLE.LOADING'] }}</span> 
            </div>
          </div> -->
        </div>
      </div>
      <div class="cathectic-shade-right" v-show="right_allBetReloading">
        <div class="shade-fixed">
          <div class="load-data-wrap col is-detail details_data_load" style="margin-top: 113px;">
            <div class="fit"></div>
            <div class="column yb-flex-center empty">
              <div class="loading-wrap right_details_loading" :class="{'cs-en':selectedLang== '1'}">
                <div class="img-loading custom-format-img-loading"></div>
                <div class="text-center loading-text flex items-end justify-center">
                  <span>{{ langList.sportTableLang['SPORT_TABLE.LOADING'] }}</span> <!--数据加载中...请稍后-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="screen">
        <div class="v-scroll-area fit vrow relative-position right_details_wrap">
          <div class="content-wrap fit">
            <allBetHeader :mode="'firstEvent'"></allBetHeader>
            <allBetContent :mode="'firstEvent'"></allBetContent>
            <div class="scroll-footer" style="bottom: 0px;"></div>
          </div>
        </div>
      </div>
    </div>

    
  </div>
</template>
<script>
import {
    mapGetters
} from 'vuex'

import EventBus from '../../../events/event-bus'
import allBetHeader from '../../sport/allBetHeader'
import allBetContent from '../../sport/allBetContent'

export default {
  components: {
    allBetHeader,
    allBetContent,
  },
  computed: {
    ...mapGetters([
      'selectedBettype',
      'langList',
      'betLang',
      'frameWidthHeight',
      'right_allBetReloading',
      'specialEvent',
    ]),
    LeftMenu_heightPX: function () {
        return this.$store.getters.frameWidthHeight.height.currentHeight-100
    },
    right_widthPX: function () {
        return this.$store.getters.frameWidthHeight.width.RightPage_current
    },
  },
  data() {
    return {
      showEveBanner: true,
      showUnfoldBtn: false,
      selectedLang: window._langid,
    }
  },
  methods: {
    
  },
  beforeMount() {
    // EventBus.$on('test', ((view) => {
    //   // this.showUnfoldRight()
    // }).bind(this))
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsRight/index.vue